export const shuffleToken = (token: string | null): string => {
  if (token === null) return ''
  const [a, b, c] = token.split('.')
  return [a, c, b].join('.')
}
